import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-nacho-header',
    templateUrl: './nacho-header.component.html',
    styleUrls: ['./nacho-header.component.scss'],
    standalone: false
})
export class NachoHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
